export const PR_RANDOM = getRandomId();

export function getRandomId() {
  return String(Math.floor(Math.random() * 4294967295) + 1);
}

export interface IAdfoxConstants {
  p1: string;
  p2: string;
  pr: string;
  puid15: string;
  pct: string;
  pfc: string;
  pfb: string;
  plp: string;
  pli: string;
  pop: string;
  pt: string;
}
